import { render, staticRenderFns } from "./IntestinalCheck.vue?vue&type=template&id=086824eb&scoped=true&"
import script from "./IntestinalCheck.vue?vue&type=script&lang=js&"
export * from "./IntestinalCheck.vue?vue&type=script&lang=js&"
import style0 from "./IntestinalCheck.vue?vue&type=style&index=0&id=086824eb&scoped=true&lang=css&"
import style1 from "./IntestinalCheck.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "086824eb",
  null
  
)

export default component.exports